export default "__VITE_ASSET__eRnzxvXQ__"